import { type MiddlewhereFilter } from '../components/filter/FilterItemManager';
import { parseDate } from '../components/Utils';

export default function getDefaultFilters({
	settings,
	defaultFilters,
	userData
}: {
	settings: any;
	defaultFilters: MiddlewhereFilter[];
	userData: any;
}) {
	if (userData.user_role_external) {
		if (settings.modu_title === 'erp_orders')
			return [
				...defaultFilters,
				{
					filt_field: 'ords_user_salesperson_uid',
					filt_clause: 'equals',
					filt_value: userData.user_uid
				},
				{
					filt_field: 'ords_d_order',
					filt_clause: 'greater_equal',
					filt_value: parseDate('01/01/2021 00:00:00')
				}
			];

		if (settings.modu_title === 'orders')
			return [
				...defaultFilters,
				{
					filt_field: 'comp_user_assigned_2_uid',
					filt_clause: 'equals',
					filt_value: userData.user_uid
				}
			];

		return [
			...defaultFilters,
			{
				filt_field: `${settings.modu_short}_user_assigned_2_uid`,
				filt_clause: 'equals',
				filt_value: userData.user_uid
			}
		];
	}

	if (userData.user_role === 'buyer' && settings.modu_title === 'companies')
		return [...defaultFilters, { filt_field: 'comp_core_id', filt_clause: 'in', filt_value: [32, 3] }];

	return defaultFilters;
}
